"use strict";
/* eslint-disable complexity */
/* eslint-disable no-console */
// constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameCCLoader = void 0;
const frameCCBaseLoader_1 = require("../../appLoaders/frameCCBaseLoader");
const frameCCLoader = params => {
    (0, frameCCBaseLoader_1.frameCCLoaderBase)(params);
};
exports.frameCCLoader = frameCCLoader;
//# sourceMappingURL=frameCCLoader.js.map